<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="rack" title="List of Abbreviations and Short Names">
<p class="fmh"><span class="right_1" epub:type="pagebreak" id="page_xv" title="xv"><a href="#/text/9780253044792_Contents#abbrev">LIST OF ABBREVIATIONS AND SHORT NAMES</a></span></p>
<p class="hang">ANIC: Arhivele Naţionale Istorice Centrale, National Central Historical Archives, Bucharest</p>
<p class="hanga">Fond Cabinetul Consiliului de Miniştri</p>
<p class="hanga">Fond: CC al PCR-Cancelarie</p>
<p class="hang">AINIM: Arhiva Institutului Naţional al Monumentelor Istorice, Archives of the National Institute of Historic Monuments (currently Institutul Naţional al Patrimoniului, National Institute of Patrimony), Bucharest</p>
<p class="hang">City Museum: Muzeul de Istorie a Oraşului Bucureşti, the Museum of History of the City of Bucharest</p>
<p class="hang">DHM: Direcţia Monumentelor Istorice, the Department of Historic Monuments (1947–77), Bucharest</p>
<p class="hang">Project Bucharest: Institutul “Proiect Bucureşti,” Bucharest</p>
<p class="hang">city council: Sfatul Popular al Municipiului Bucureşti, the city people’s council (1947–89)</p>
<p class="hang">city hall: Primăria municipiului Bucureşti, Bucharest’s city hall (1990–)</p>
<p class="hang">State Committee for Architecture: Comitetul de Stat pentru Construcţii, Arhitectură şi Sistematizare, the State Committee for Building, Architecture, and Urban Planning, Bucharest</p>
<p class="hang">UNESCO archives: Fond Romania, Paris<span class="right_1" epub:type="pagebreak" id="page_xvi" title="xvi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044792_Abbreviations.vue?2e8d8b55